import { client } from "../utils/netlify";
import { setCookie, getCookie } from "cookies-next";
import store from "@/redux/store";
import { isGiftCardType, isDonationProduct  } from "@/helpers/pdpHelpers/priceHelpers";
import { updateProductInCart } from "./cartHelpers";
import { reportError } from "./errorHelper";

export const updateUserCause = async (request) => {
  try {
    let checkoutId = getCookie("userdataToken");
    const storage = window.localStorage;
    checkoutId = JSON.parse(checkoutId);
    request.customerAccessTokem = checkoutId.accessToken;
    const resp = await client("update-user-cause", request)
    if(resp) {
      storage.setItem("user_cause", JSON.stringify(request.cause));
    }
    return resp;
  } catch (error) {
    reportError("Error in update user cause")
    reportError(error)
    return {}
  }
};

//SUP-2619 - When charity is changed, update the cart list line items, to send correct charity on the Order confirmation.
export const updateCartWhenCharityUpdates = async (updatedCause, cause_list) => {
  var cart_list = JSON.parse(sessionStorage.getItem("cart_list"));
  let request = {};
  request.lineItems = [];
  cart_list?.lines?.edges.map(async product => {
    // Find the index of 'cause' in the attributes array
    const causeIndex = product?.node?.attributes.findIndex(attr => attr.key === '_cause');
    // If 'cause' is found, update its value
    if (causeIndex !== -1) {
      product.node.attributes[causeIndex].value = updatedCause;
    }
    request.lineItems.push({
      id: product?.node?.id,
      merchandiseId: product?.node?.merchandise?.id,
      attributes: product?.node?.attributes
    });
  })
  await updateProductInCart(request);
  return true;
}

export const saveUserCharityLocalStorage = (cause) => {
    const storage = window.localStorage;
    storage.setItem("user_cause", JSON.stringify(cause));
  return true;
};

export const getUserCauseDetails = () => {
  const user_cause = store.getState().general.user_cause;
  let considerCause =
    typeof user_cause != "undefined" && user_cause
      ? user_cause
      : store.getState().general.default_cause;

  let cause_list = store.getState().general.cause_list;

  let cause = cause_list && cause_list.filter((eachItems) => {
    if (
      JSON.stringify(eachItems.short_code) == considerCause ||
      eachItems.short_code == considerCause
    ) {
      return true;
    } else {
      return false;
    }
  });
  return cause;
};

export const getCauseDetailsByName = (causeName) => {
  let cause_list = store.getState().general.cause_list;
  let cause = cause_list.filter((eachItems) => {
    if (eachItems.name.toUpperCase() == causeName.toUpperCase()) {
      return true;
    } else {
      return false;
    }
  });
  return cause;
};

export const getTotalPriceForBenefit = (itemList) => {
  let skipBenefitForProductCount = 0;
  let hideImpactMessage = false;
  let itemTotalPrice, olivelaCostTotal = 0;
  let sum, sumTotal = 0;
  // summing the total olivela cost
  // Excluding gift card & donation product amount
  sum = itemList?.lines?.edges.reduce((previousValue, currentValue) => {
    let giftcardType = isGiftCardType(currentValue?.node?.merchandise);
    let donationProduct = isDonationProduct(currentValue?.node?.merchandise);
    if(giftcardType || donationProduct){
      sumTotal = sumTotal;
    } else {
      sumTotal = previousValue + ((currentValue?.node?.merchandise?.olivela_cost?.value)*currentValue?.node?.quantity) + (9*currentValue?.node?.quantity);
    }
    return sumTotal;
  }, 0)
  if(!isNaN(sum)){
    olivelaCostTotal = sum;
  }

  itemTotalPrice = parseInt(itemList?.estimatedCost?.subtotalAmount?.amount)-olivelaCostTotal;
  itemList?.lines?.edges.forEach(element=>{
    let giftcardType = isGiftCardType(element?.node?.merchandise);
    let donationProduct = isDonationProduct(element?.node?.merchandise);
    if(giftcardType || donationProduct) {
      skipBenefitForProductCount++;
      itemTotalPrice -= parseInt(element?.node?.quantity)*parseInt(element?.node?.merchandise?.priceV2?.amount);
    }
  });
  
  if(itemList?.lines?.edges.length === skipBenefitForProductCount){
    //Impact message hiding if only gift card or only donation product present
    hideImpactMessage = true;
  }
  return { "item_total_price" : itemTotalPrice, "hide_impact_message" : hideImpactMessage};
}

export const getOverallBenefitValue = async () => {
  try {
    const resp = await client("get-benefit-data-from-blob")
    return resp;
  } catch (error) {
      reportError("Error in get overall benefit value")
      reportError(error)
      return {};
  }
};

export const getUserCauseFromLocalStorage = () => {
  try {
    const storage = window.localStorage;
    let userCause = JSON.parse(storage.getItem("user_cause"));
    return userCause ? userCause : ''; // Return an empty string if userCause is null
  } catch (error) {
    reportError(error, "error in getUserCauseFromLocalStorage");
    return ''; // Return an empty string in case of an error
  }
};

export const getUserCauseFromUserTag = (userData) => {
  try {
    let userCause = userData?.customer?.tags?.find(e=> e.includes("cause:"))
    userCause = userCause?.split(":")[1];
    return userCause ? userCause : ''; // Return an empty string if userCause is null
  } catch (error) {
    reportError(error, "error in getUserCauseFromUserTag");
    return ''; // Return an empty string in case of an error
  }
};